module.exports = __webpack_public_path__ + "img/project-27.85803ffe.png";